export default __webpack_public_path__ + "static/media/Raze_artwork.bd376cbd.png";